var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wsk-root wsk-app ws-fields-arrangement",class:'theme--' + _vm.conf.theme,attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"deployment-test-123"}}),_c('layout-default'),_c('ws-outdated-modal'),(_vm.devUtils)?_c('theme-switcher'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }